<template>
<v-card>
        <v-toolbar
           dense flat
  style="border-bottom: solid #999 1px;border-radius: 0;"
          color="#eee"
        >
       
          <v-toolbar-title>تراکنش ها</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
             <v-btn
            icon
            
            @click="$store.state.financial = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          </v-toolbar-items>
        </v-toolbar>
<v-container>
<v-row>
<v-col cols="12">
    
      <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
            ردیف
          </th>
          <th class="text-left">
            مبلغ
          </th>
          <th class="text-left">
            تاریخ
          </th>
            <th class="text-left">
            کد پیگیری
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item,index) in transactions"
          :key="item.id"
        >
          <td>{{ index+1 }}</td>
          <td>{{ item.price }}</td>
          <td>{{ item.created_at | moment('YYYY/MM/DD') }}</td>
          <td>{{ item.refid }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>

</v-col>
</v-row>
</v-container>
      </v-card>
</template>
<script>
  export default {
    data: () => ({
      transactions : []
    }),
 mounted(){

     var senddata = {  data: {  data: ['select', 'agent_transactions', '*',{agent_id:this.$store.state.user_branding.id,status:100}] }, actions: ['get'] };
     this.api_get(senddata).then(data => {
console.log(data)
this.transactions = data.data
     })

 },
  methods: {
  }
  }
</script>